module.exports = __webpack_public_path__ + "static/media/CCU_Arg-16.e01431bf.png";